import { Skeleton } from "antd";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { ArrowRight, ArrowLeftCircle } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../Firebase/firebase";
import RecipeSearch from "../SearchBar/RecipeSearch";
import "./Dialog_card.css";

function DialogCardMobileView(props) {
  const { defaultPage, recipeSideMenuObject, show, setMenuObject } = props;
  const [posts, setPosts] = useState([]);
  const [loadingExplorePosts, setLoadingExplorePosts] = useState(false);

  function manipulateDescription(postDesc) {
    let a = postDesc.data().desc;

    if (postDesc.data().desc.length > 75) {
      a = postDesc.data().desc.substr(0, 75);
      a += "...";
    }
    return a;
  }

  useEffect(() => {
    setLoadingExplorePosts(true);
    if (show) {
      const q = query(
        collection(db, "posts"),
        where("privatePosts", "==", false),
        limit(3),
        orderBy("rating", "desc"),
        orderBy("createdAt", "desc")
      );
      getDocs(q).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          setPosts((post) => [...post, doc]);
        });
        setLoadingExplorePosts(false);
      });
    } else {
      setLoadingExplorePosts(false);
      setPosts([]);
    }
  }, [show]);
  const navigate = useNavigate();
  if (defaultPage === "Explore") {
    return (
      <>
        <div className="flex flex-col p-5 m-5">
          Explore the latest recipes
          <div
            className="p-5 m-5"
            onClick={() => {
              setMenuObject("");
            }}
          >
            <ArrowLeftCircle />
          </div>
          {loadingExplorePosts === true ? (
            <Skeleton active paragraph={{ rows: 3 }} />
          ) : (
            posts.map((post) => (
              <div className="dialog_card d_card">
                <h2>{post.data().title}</h2>
                <div className="dialog_card_description_limited">
                  <p>
                    {post.data().desc === undefined
                      ? ""
                      : manipulateDescription(post)}
                  </p>
                </div>
                {/* <div className="dialog_card_category_label">
                {post.data().category}
              </div> */}
                <div
                  className="dialog_readmore"
                  onClick={() => {
                    navigate(`/post/${post.data().category}/${post.id}`);
                  }}
                >
                  <span>Read More</span> <ArrowRight />
                </div>
              </div>
            ))
          )}
        </div>
      </>
    );
  } else if (defaultPage === "Find A Recipe") {
    return (
      <div className="flex flex-col">
        <div className="p-5 m-5" onClick={() => setMenuObject("")}>
          <ArrowLeftCircle />
        </div>
        <RecipeSearch />
      </div>
    );
  } else {
    return (
      <>
        <div className="block w-3/5">
          <div className="p-5 m-5" onClick={() => setMenuObject("")}>
            <ArrowLeftCircle />
          </div>

          <div className="flex gap-10 justify-between w-max pl-10 h-auto ">
            <h3>{defaultPage}</h3>
            <a
              href={`/explore/${defaultPage}/all`}
              className="dialog_page_title_link"
            >
              {"  SEE ALL " + defaultPage}
            </a>
          </div>
          <div className="flex flex-col">
            <ul className=" gap-10 mr-10 m-20 inline">
              {recipeSideMenuObject.linkItems.map((innerMenuOptions) => (
                <li
                  className="p-2 m-2 inline-block cursor-pointer"
                  onClick={() => {
                    navigate(`/explore/${defaultPage}/${innerMenuOptions}`, {
                      replace: true,
                    });
                    window.location.reload();
                  }}
                >
                  {innerMenuOptions}
                </li>
              ))}
            </ul>
            <div className="dialog_card_sidebar">
              <h1>Sponsor</h1>
              <div className="dialog_card_sidebar_ad"></div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DialogCardMobileView;
